import { useContext } from "react";

import { DomainBrandingContext } from "./DomainBrandingContext";

export const useDomainBrandingContext = () => {
  return useContext(DomainBrandingContext);
};
